// This icon file is generated automatically.
var PTimeOutOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M7 0a7 7 0 100 14A7 7 0 007 0zm0 12.81A5.81 5.81 0 117 1.2 5.81 5.81 0 017 12.8zM5.62 4.5h-.75a.13.13 0 00-.12.13v4.75c0 .06.06.12.13.12h.75c.06 0 .12-.06.12-.13V4.63a.13.13 0 00-.13-.13zm3.5 0h-.74a.13.13 0 00-.13.13v4.75c0 .06.06.12.13.12h.74c.07 0 .13-.06.13-.13V4.63a.13.13 0 00-.13-.13z", "fill-rule": "nonzero" } }] }, "name": "p-time-out", "theme": "outlined" };
export default PTimeOutOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PTimeOutOutlined.js
// module id = 3693
// module chunks = 0